<template>
  <div class="w-full">
    <BaseSelect
      v-model="value"
      :options="blocksOptions"
      name="ticket"
      class="w-full"
    />
  </div>
</template>

<script setup lang="ts">
import { BlockType, usePageEditor } from '~/stores/page-editor'

interface PropsInterface {
  modelValue?: string | number
}

const props = withDefaults(defineProps<PropsInterface>(), {
  modelValue: undefined,
})

const emit = defineEmits(['update:modelValue'])
const pageEditorStore = usePageEditor()

const blocksOptions = computed(() => {
  return pageEditorStore.editorBlocks
    .filter((block) => block.type !== BlockType.FloatingBanner)
    .map((block) => {
      const value = pageEditorStore.getBlockId(block)
      const typeTitle =
        block.editorSchema?.title || BlockType[block.type] || 'Unknown'
      const label = `[${typeTitle}] ${value}`

      return {
        label: block.is_visible ? label : `${label} (hidden)`,
        value,
      }
    })
})

const value = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})
</script>
